
import Vue from "vue";
import RULES from "@/mixins/rules";
import { Espectacular, FileDocument, SeccionEspectacular } from "@/models/Espectacular";
import EstablecimientoService from "@/services/EstablecimientoService";
import CatastroService from "@/services/CatastroService";
import { VForm } from "@/types/formvalidate";
import CustomFile from "@/components/Common/CustomFile.vue";
import Direccion from "@/components/Beneficiarios/Direccion.vue";
import { Domicilio } from "@/models/Domicilio";
import { mapGetters } from "vuex";
import EventBus from "@/plugins/event-bus";
import { EspectacularService } from "@/services/EspectacularService";
import TipoAnuncioService from "@/services/TipoAnuncioService";
import AnuncioExternoService from "@/services/AnuncioExternoService";
import PredialEstadoCuenta from '@/components/Common/EstadoCuenta.vue';

interface Rules {
  required: string;
  longDigit: (length: number) => string;
}

export default Vue.extend({
  name: "SolicitudEspectacularForm",
  mixins: [RULES],
  props: {
    idEspectacular: {
      type: [Number, String],
      default: 0
    },
    styles: {
      type: String,
      default: "margin-top: 0px"
    },
  },
  components: {
    Direccion, 
    CustomFile,
    PredialEstadoCuenta
  },
  data() {
    return {
      espectacularService: new EspectacularService('solicitud_espectaculares'),
      formData: new Espectacular(),
      isNew: true,
      rules: {} as Rules,
      filedsFiles: [
        "colindansia_norte",
        "colindansia_sur",
        "croquis_ubicacion",
        "solventacion_acta_inspeccion",
        "certificado_ubicacion",
        "poliza_seguro",
        "luminosidad",
        "constancia_uso_suelo",
        'permiso_anuncio',
        "contrato_arrendamiento"
      ],
      loading: false,
      disabled: true,
      constanciaUsoSuelo: false,
      permisoAnuncio: false,
      dialogEstadoGenerado: false,
      documento:  null as any,
      enviado_revision: false,
      dialogPredial: false,
      dialogView: false,
      domicilio: Domicilio,
      tiposAnuncios: [] as any[],
      tipo_propiedad: [
        {
          id: 1,
          tipo: 'Propio'
        },
        {
          id: 2,
          tipo: 'Arrendamiento'
        }
      ],
      newSeccionLargo: 0,
      newSeccionAncho: 0,
      tipoAnuncionesAllow: [2, 3, 4, 5, 10],
      permisoLuminosidad: false,
      disabledBtnGuardar: false,
      dialogEstadoCuenta: false,
    };
  }, 
  methods: {
    addSeccion() {
      if (this.newSeccionLargo && this.newSeccionAncho) {
        let obj: SeccionEspectacular = {
          solicitud_espectacular_id: this.formData.id,
          ancho: this.newSeccionAncho,
          largo: this.newSeccionLargo
        };

        this.formData.secciones.push(obj);

        this.newSeccionLargo = 0;
        this.newSeccionAncho = 0;
      }
    },
    removeConditional(index: number) {
      this.formData.secciones.splice(index, 1);
      this.$forceUpdate();
    },
    async getData() {
        
        if (this.idEspectacular !== 0) {
            this.isNew = false;
            const { data } = await this.espectacularService.getSolicitudesEspectacularById(this.idEspectacular);
            this.formData = data;
            this.formData.documentos = {
              colindansia_norte: { file: '' },
              colindansia_sur: { file: '' },
              croquis_ubicacion: { file: '' },
              solventacion_acta_inspeccion: { file: '' },
              certificado_ubicacion: { file: '' },
              poliza_seguro: { file: '' },
              luminosidad: { file: '' },
              constancia_uso_suelo: { file: '' },
              permiso_anuncio: { file: '' },
              contrato_arrendamiento: { file: '' }
            };

            if(this.formData.secciones == null) {
              this.formData.secciones = [];
            }

            this.enviado_revision = this.formData.estatus_revision == 10 ? true : false;

            if(this.formData.colindansia_norte_file == null) {
              this.formData.colindansia_norte_file = new FileDocument();
            }
            if(this.formData.colindansia_sur_file == null) {
              this.formData.colindansia_sur_file = new FileDocument();
            }
            if(this.formData.croquis_ubicacion_file == null) {
              this.formData.croquis_ubicacion_file = new FileDocument();
            }
            if(this.formData.solventacion_acta_inspeccion_file == null) {
              this.formData.solventacion_acta_inspeccion_file = new FileDocument();
            }
            if(this.formData.certificado_ubicacion_file == null) {
              this.formData.certificado_ubicacion_file = new FileDocument();
            }
            if(this.formData.poliza_seguro_file == null) {
              this.formData.poliza_seguro_file = new FileDocument();
            }
            if(this.formData.luminosidad_file == null) {
              this.formData.luminosidad_file = new FileDocument();
            }
            if(this.formData.constancia_uso_suelo_file == null) {
              this.formData.constancia_uso_suelo_file = new FileDocument();
            }
            if(this.formData.permiso_anuncio_file == null) {
              this.formData.permiso_anuncio_file = new FileDocument();
            }

            if(this.formData.constancia_uso_suelo_file.id == 0 && this.formData.constancia_uso_suelo_exist != null) {
              this.constanciaUsoSuelo = true
            }

            if(this.formData.permiso_anuncio_file.id == 0 && this.formData.permiso_anuncio_externo?.id != null) {
              this.permisoAnuncio = true
            }

            if(this.formData.contrato_arrendamiento_file == null) {
              this.formData.contrato_arrendamiento_file = new FileDocument();
            }

            if(this.formData.luminosidad_file.id > 0 && this.formData.luminosidad != null){
              this.permisoLuminosidad = true;
            }

            const estatusAviables = [0, 1, 5, 9, 11, 13, 15]
            this.disabled = !estatusAviables.includes(this.formData.estatus_revision)
            console.log(this.formData.constancia_uso_suelo_exist)            
            
        } else {
            this.isNew = true;
        }

        await TipoAnuncioService.getAll()
          .then((response) => {
            this.tiposAnuncios = response.data.filter((item: any) => this.tipoAnuncionesAllow.includes(item.id));
          })
    },
    async save() {
        this.disabledBtnGuardar = true;
        this.formData.contribuyente_id = this.contribuyente.id;

        if (this.form.validate()) {
          EventBus.$emit("update-direccion");
            let data = null;
            let formdataObj = Object.assign({}, this.formData);

            for (const item of this.filedsFiles) {
            if (this.formData.documentos[item] && (this.formData.documentos[item].file != '' && this.formData.documentos[item].file != null)) {

                let formDataDocuments = new FormData();
                formDataDocuments = await this.objectToFormData(this.formData.documentos, formDataDocuments);
                const base64Documents: Record<string, Base64File> = await this.objectToBase64(formDataDocuments);

                if (base64Documents[`documentos[${item}][file]`]['file']!= null) {
                (this.formData as unknown as Record<string, string>)[item] = base64Documents[`documentos[${item}][file]`]['file'];
                }
            }
            }

            setTimeout(async () => {
                if(this.formData.id!= 0)
                    data = await this.espectacularService.updateSolicitudesEspectacular(this.formData.id, this.formData);
                else
                    data = await this.espectacularService.create(this.formData);

                if (data.data.success) {
                    this.$toast.success(data.data.message);
                    this.formData.id = data.data.data.id;
                    this.isNew = false;
                    this.disabledBtnGuardar = false;
                }else{
                    this.$toast.error(data.data.message);
                    this.disabledBtnGuardar = false;
                }
            }, 1000)
                
        }else{
            this.$toast.warning("Por favor, llene todos los campos obligatorios.");
            this.disabledBtnGuardar = false;
        }
    },
    async changeStatus(idStatus: number) {
      const object = {
        'estatus_revision': idStatus
      }

      let { data } = await this.espectacularService.changeStatus(this.formData.id, object);

      if (data.success) {
        this.$toast.success(data.message);
        this.getData();
      } else {
        this.$toast.error(data.message);
      }
    },
    async deleteSolicitud() {
      const object = {
        'estatus_revision': 18
      }

      let { data } = await this.espectacularService.changeStatus(this.formData.id, object);

      if (data.success) {
        this.$toast.success(data.message);
        await this.$router.push({name: 'solicitudesTorres'});
      } else {
        this.$toast.error(data.message);
      }
    },
    async objectToFormData(obj: any, formData: any) {
      Object.entries(obj).forEach(([key, value]: any) => {
        if(value.file === null || value.file === '') {
          return;
        }

        formData.append(`documentos[${key}][file]`, value.file);
        formData.append(`documentos[${key}][code]`, key);
      });

      return formData;
    },
    toBase64(file: File): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
      });
    },
    async objectToBase64(formData: FormData): Promise<Record<string, Base64File>> {
      const result: Record<string, Base64File> = {};

      for (const [key, value] of formData.entries()) {
        if (value instanceof File) {
          result[key] = {
            file: await this.toBase64(value),
            code: key
          };
        }
      }
      return result;
    },
    async consultarCatastro(){
      if(this.formData.clave_catastral.length == 17){
        let {data: {resultados: catastro}} = await CatastroService.searchByClaveCatastral(this.formData.clave_catastral);

        catastro != false ? this.disabled = false : this.disabled = true;

        if(catastro != false){
          let { data } = await EstablecimientoService.getPagoPredial(this.formData.clave_catastral);

          if (data.data) {
            this.disabled = false;
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message)
            this.dialogPredial = true;
          }

          this.formData.ubicacion.codigo_postal = catastro.cp.toString();
          this.formData.ubicacion.localidad_id = catastro.id_localidad;
          this.formData.ubicacion.colonia_id = catastro.id_colonia;
          this.formData.ubicacion.calle_id = catastro.id_calle;
          this.formData.ubicacion.numero_exterior = catastro.num_predio;
        }else{
          this.$toast.error("La clave no ha sido encontrada en catastro")
        }
      }

      const estatusAviables = [0, 1, 5, 9, 11, 13, 15]
      this.disabled = !estatusAviables.includes(this.formData.estatus_revision)
    },
    async verConstanciaUsoSuelo(){
        await this.espectacularService.viewEstadoCuenta(`constancia_uso_suelo/${this.formData.constancia_uso_suelo_exist.id}/viewestadocuenta`, {},  'GET', 'Temp')
        .then((response) => {
            let file = new Blob([response.data],{type: response.headers['content-type']});
            const url = window.URL.createObjectURL(file);
            const tipoArchivo = 'Constancia Uso de suelo'
            //@ts-ignore
            this.documento = {
                title: tipoArchivo,
                url: url,
                mime: response.headers['content-type']
            }
            this.dialogEstadoGenerado= true;
            this.$toast.success('Constancia Uso de Suelo.');
        })
    },
    async verPermisoAnuncio() {
      await AnuncioExternoService.generarFmtAutorizacion(
          `anuncio/${this.formData.permiso_anuncio_externo?.id}/generateformatoautorizacion`,
          'POST',
          'Temp'
      )
          .then((response) => {
            let file = new Blob([response.data],{type: response.headers['content-type']});
            const url = window.URL.createObjectURL(file);
            const tipoArchivo = 'test'
            //@ts-ignore
            this.documento = {
              title: tipoArchivo,
              url: url,
              mime: response.headers['content-type']
            }
            //this.dialogAutorizacionfile = true;
            this.$toast.success('Formato de autorización generado.');
          }).catch((error) => {
            this.$toast.error(error.response.data.message)
          })
    },
    setDomicilio(domicilio: Domicilio) {
      console.log(this.formData.ubicacion)
      this.formData.ubicacion = Object.assign({}, domicilio);
      
    },
    pagarPredialLinea(){
      window.open('https://predial.opb.gob.mx/predial', '_blank')
      //window.open(`https://predial.opb.gob.mx/predial?clave_catastral=${this.formData.clave_catastral}`, '_blank')
    },
    async generarPagoPredial(){
      //this.dialogEstadoCuenta = true;
       await EstablecimientoService.newRequest(`licencia/${this.formData.clave_catastral}/generatePagoPredial`,{},'POST','Temp')
      .then((response) => {
          let file = new Blob([response.data],{type: response.headers['content-type']});
          const url = window.URL.createObjectURL(file);
          const tipoArchivo = 'Estado de cuenta.'
          //@ts-ignore
          this.documento = {
              title: tipoArchivo,
              url: url,
              mime: response.headers['content-type'] 
          }
          this.dialogView = true;
      }) 
    },
    closeEstadoCuenta() {
      this.dialogEstadoCuenta = false;
    },
  },
  computed: {    
    form(): VForm {
      return this.$refs.form as VForm
    },
    formDir(): VForm {
      return this.$refs.formDireccion as VForm;
    },
    ...mapGetters({
      usuario: "usuario",
      id: "id",
      contribuyente: "contribuyente",
      mini: "sidebar",
    }),
    computedRules(): string[] {
      // Computa el valor en función de la propiedad 'disabled'
      return this.disabled
          ? [this.rules.required, this.rules.longDigit(17)!]
          : [];
    },
  },
  mounted() {
    this.getData();
  },
});

interface Base64File {
  file: string;
  code: string;
}
